import React, { useEffect, useState } from "react"
import { HubConnectionBuilder } from "@microsoft/signalr"
import { getJwtToken } from "../services/auth-service.js"
import { SendError } from "../services/error-log-service.js"

const defaultState = {
  hubConnection: {},
  connectedAccounts: [],
}

const HubContext = React.createContext(defaultState)

const HubProvider = ({ children }) => {
  const hubUrl = process.env.GATSBY_OUTIBLE_HUB_URL
  const [hubConnection, setHubConnection] = useState(null)
  const [connectedAccounts, setConnectedAccounts] = useState([])

  useEffect(() => {
    const token = getJwtToken()

    if (token === null) return

    const newHubConnection = new HubConnectionBuilder()
      .withUrl(hubUrl + "presence", {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect()
      .build()

    setHubConnection(newHubConnection)
  }, [hubUrl])

  useEffect(() => {
    if (!hubConnection) return

    const onAccountConnected = userId => {
      setConnectedAccounts(accounts =>
        accounts.includes(userId) ? accounts : [...accounts, userId],
      )
    }

    const onAccountDisconnected = userId => {
      setConnectedAccounts(accounts => accounts.filter(id => id !== userId))
    }

    const onGetOnlineAccounts = userIds => {
      setConnectedAccounts(accounts => [...new Set([...accounts, ...userIds])])
    }

    hubConnection.on("AccountConnected", onAccountConnected)
    hubConnection.on("AccountDisconnected", onAccountDisconnected)
    hubConnection.on("GetOnlineAccounts", onGetOnlineAccounts)

    hubConnection.start().catch(ex => {
      SendError(ex)
      console.log("Hub connection failed: ", ex)
    })

    return () => {
      hubConnection.off("AccountConnected", onAccountConnected)
      hubConnection.off("AccountDisconnected", onAccountDisconnected)
      hubConnection.off("GetOnlineAccounts", onGetOnlineAccounts)
      hubConnection.stop()
    }
  }, [hubConnection])

  return (
    <HubContext.Provider value={{ hubConnection, connectedAccounts }}>
      {children}
    </HubContext.Provider>
  )
}

export default HubContext
export { HubProvider }
